import permissionKeys from "@/lib/permissionKeys";

export function hasPermission(permissionKey: any) {
  const p = JSON.parse(sessionStorage.permission || "[]");
  if (permissionKey instanceof Array) { // 為array時 是否有符合其中的一項permission
    return !!permissionKey.find(val => p.indexOf(parseInt(getPermission(val))) > -1);
  }
  return p.indexOf(getPermission(permissionKey)) > -1;
}

function getPermission(permissionKey: any) {
  if (typeof permissionKey === 'number') {
    return permissionKey;
  }
  return permissionKeys[permissionKey];
}